import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("app_atkey");
    if (token) {
      config.headers.Authorization = `bearer ${token}`;
    }
    return config;
  },
  (err) => {
    return Promise.resolve(err);
  }
);

interface FactorySugerState {
  data: any[];
  error: string;
  success: boolean;
  isLoading: boolean;
}

const initialState: FactorySugerState = {
  data: [],
  error: "",
  success: false,
  isLoading: false,
};

const SugerFacrory = createSlice({
  name: "factorySuger",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFactorySuger.pending, (state) => {
        state.isLoading = true;
        state.error = "";
      })
      .addCase(fetchFactorySuger.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.success = true;
      })
      .addCase(fetchFactorySuger.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Something went wrong";
        state.success = false;
      })
      .addCase(addFactorySuger.fulfilled, (state, action) => {
        if (Array.isArray(state.data)) {
          state.data.push(action.payload);
        } else {
          console.error("State data is not an array:", state.data);
        }
      })
      .addCase(deleteFactorySuger.fulfilled, (state, action) => {
        state.data = state.data.filter(
          (item: any) => item.dataID !== action.payload.dataID
        );
      })
      .addCase(updateFactorySuger.fulfilled, (state, action) => {
        const index = state.data.findIndex(
          (item) => item.dataID === action.payload.dataID
        );
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      });
  },
});

// خطای 7: نام thunkها بسیار طولانی و تکراری بود - ساده‌سازی شد
export const fetchFactorySuger = createAsyncThunk(
  "factorySuger/fetch",
  async (url: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(url);
      return response?.data?.items;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addFactorySuger = createAsyncThunk(
  "factorySuger/add",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://api.havirkesht.ir/factory_sugar/",
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.log(error, "😁😁😁");

      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message || "Network Error";
        return rejectWithValue({
          message,
          status: error.response?.status,
        });
      }
      return rejectWithValue({
        message: "An unknown error occurred",
      });
    }
  }
);

export const deleteFactorySuger = createAsyncThunk(
  "factorySuger/delete",
  async (dataID: string, { rejectWithValue }) => {
    try {
      await axios.delete(`https://api.havirkesht.ir/factory_sugar/${dataID}`);
      return { dataID };
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const updateFactorySuger = createAsyncThunk(
  "factorySuger/update",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `https://api.havirkesht.ir/factory_sugar/${data.dataID}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// خطای 8: نام reducer اشتباه بود - باید از نام slice استفاده می‌شد
export default SugerFacrory.reducer;
